import {
  apiSearchBySlug,
  apiCreateCertificate,
  apiRegister,
  apiDetailOrder,
  apiCreateOrder,
  apiRenew,
  apiGetPrice,
  apiGetVehiceType,
  apiGetListGift,
  apiSearch,
  apiGetCarBrand,
  apiGetCarCompany,
  apiCreateCertificateMotor,
  apiGetPriceMotor,
} from "./urls"
import http from "../index"
import QueryString from "qs"

const searchBySlug = (slug, body) => http.post(apiSearchBySlug(slug), body)
const CreateCertificate = body => http.post(apiCreateCertificate, body)
const Register = body => http.post(apiRegister, body)
const DetailOrder = id => http.get(apiDetailOrder(id))
const GetPrice = body => http.post(apiGetPrice, body)
const RenewOrder = (id, body) => http.post(apiRenew(id), body)
const GetVehiceType = () => http.get(apiGetVehiceType)
const GetListGift = () => http.get(apiGetListGift)
const SearchNoCaptcha = (slug, body) => http.post(apiSearch(slug), body)
const GetCarCompany = () => http.get(apiGetCarCompany)
const GetCarBrand = params => http.get(apiGetCarBrand, { params })
const CreateCertificateMotor = body => http.post(apiCreateCertificateMotor, body)
const GetPriceMotor = body => http.post(apiGetPriceMotor, body)


const ClientSearchService = {
  searchBySlug,
  CreateCertificate,
  Register,
  DetailOrder,
  RenewOrder,
  GetPrice,
  GetVehiceType,
  GetListGift,
  SearchNoCaptcha,
  GetCarBrand,
  GetCarCompany,
  CreateCertificateMotor,
  GetPriceMotor,
}
export default ClientSearchService
